import * as React from "react";
import { SVGProps } from "react";
function SvgAdvancedSearchIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 20H3v-2h6v-2h2v6H9v-2Zm-2-7H3v-2h4V9h2v6H7v-2Zm5-9V2h2v6h-2V6H3V4h9Zm4 0h5v2h-5V4Zm-5 7h10v2H11v-2Zm2 7h8v2h-8v-2Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgAdvancedSearchIcon;
